module.exports = __webpack_public_path__ + "images/pages/for_business/sp/sec11_fb74780a2f68cb48182fb2cccae16028.jpg";